// extracted by mini-css-extract-plugin
export default {"DeleteContentTypesDialog":"DeleteContentTypesDialog_DeleteContentTypesDialog__CyD24"};